import { Fragment, type ReactNode } from 'react';

interface Props {
  caseId: string | number;
  children?: ReactNode;
}

export function Case(props: Props) {
  return (
    <Fragment>
      {props.children}
    </Fragment>
  );
}
